import React from 'react'

export default function TeamBanner() {
  return (
    <>
      <section className='team-banner-area header-gap'>
        <img src='/assets/images/home-banner-3.webp' className='img-respon' alt='Banner' />
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6 col-md-8'>
              <div className='team-head'>
                <h1 className='heading'>Driven by People, Enabled by Innovation</h1>
                <p>At Dox and Box, our strength lies in the expertise, commitment, passion of our people. It’s their dedication that transforms complex challenges into seamless document management solutions. Backed by innovation and advanced technology, our team works to deliver smarter, more efficient systems that help businesses grow with confidence.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
